import { render, staticRenderFns } from "./VipApplyLists.vue?vue&type=template&id=5e3d123c&scoped=true&"
import script from "./VipApplyLists.vue?vue&type=script&lang=js&"
export * from "./VipApplyLists.vue?vue&type=script&lang=js&"
import style0 from "./VipApplyLists.vue?vue&type=style&index=0&id=5e3d123c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d123c",
  null
  
)

export default component.exports